import { useCallback } from 'react';
import { CareCreditMethodCard, careCreditMethodCards } from '../../../components/care-credit-method-card';
import { useCareCreditSmsNumber } from '../../../hooks/use-care-credit-person-sms-number';
import { useCareCreditTranslations } from '../../../hooks/use-care-credit-translations';
import { CollectBaseStep } from '../atoms/step/collect-base-step';
import { CareCreditCollectMultiSteps } from '../collect-multi-step.types';
import { useCareCreditCollectContext } from '../context/care-credit-collect.context';

const CURRENT_STEP: CareCreditCollectMultiSteps = 'select-payment-method';
const FORM_STEP: CareCreditCollectMultiSteps = 'payment-method-form';

export const Step1SelectPaymentMethod = () => {
  const { t } = useCareCreditTranslations();

  const {
    person,
    locationId,
    hideBackButtonOnCareCreditCollect,
    onGoBack,
    onGoToMessageStep,
    multiStep: { goToStep },
  } = useCareCreditCollectContext();

  const { firstValidPhoneNumber } = useCareCreditSmsNumber({
    person,
    locationId,
  });

  const onSelectInOffice = useCallback(() => {
    goToStep({ orStep: FORM_STEP });
  }, [goToStep]);
  return (
    <CollectBaseStep
      id={CURRENT_STEP}
      label={t('How would you like to process the CareCredit payment?')}
      footer={{
        primary: null,
        secondary: null,
        back: {
          children: t('Back'),
          iconName: 'back',
        },
        showBackButton: !hideBackButtonOnCareCreditCollect,
        onClickBack: onGoBack,
      }}
    >
      <div className={careCreditMethodCards}>
        <CareCreditMethodCard iconName='forms' label={t('Submit In-Office')} onClick={onSelectInOffice} />
        <CareCreditMethodCard
          iconName='message'
          label={t('Text Link to Customer')}
          onClick={onGoToMessageStep}
          disabled={!firstValidPhoneNumber}
          disabledTooltip={!firstValidPhoneNumber ? t('No valid phone number') : undefined}
        />
      </div>
    </CollectBaseStep>
  );
};
